import script from "./productionReport.vue?vue&type=script&setup=true&lang=js"
export * from "./productionReport.vue?vue&type=script&setup=true&lang=js"

import "./productionReport.vue?vue&type=style&index=0&id=32a4b38e&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a4b38e"]])

export default __exports__